import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "../../../../components/FormElement/Select";
import Search from "../../../../components/FormElement/Search";
import TextArea from "../../../../components/FormElement/TextArea";
import URl from "../../../../components/FormElement/URl";
import DatePicker from "../../../../components/FormElement/DatePicker";
import Phone from "../../../../components/FormElement/Phone";
import Button from "../../../../components/FormElement/Button";
import ImageUpload from "../../../../components/FormElement/ImageUpload";
import LangTab from "../../../../components/FormElement/LangTab";
import { useShowAlert } from "../../../../hooks/useAlerts";
import service from "../../../../services/projects";
import Spinner from "../../../../components/Spinner/FullScreen";

import {
  Container,
  Row,
  Title,
  ButtonContainer,
  Box,
  Content,
  TarmoqlarTitle,
} from "./style";
import * as Yup from "yup";
import categoryService from "../../../../services/projectCategory";
import { FaTelegramPlane } from "react-icons/fa";
import { BsTwitter } from "react-icons/bs";
import { FaFacebook } from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";

const ProjectForm = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { error } = useShowAlert();
  const [fileList, setFileList] = useState([]);
  const [logo, setLogo] = useState([]);
  const [photo, setPhoto] = useState([]);
  const [language, setLanguage] = useState("UZL");
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    setLoading(true);
    categoryService
      .getAll()
      .then((resp) => {
        setCategories(resp);
      })
      .catch((err) => {
        console.log(err);
        error(
          "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const validationSchema = Yup.object({
    title: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    desc: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    client: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    full_desc: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    project_category: Yup.string().required("Kiritish shart!"),
    project_type: Yup.string().required("Kiritish shart!"),
    url: Yup.string().url("Noto'g'ri URL format!").required("Kiritish shart!"),
    phone: Yup.string().required("Kiritish shart!"),
    date: Yup.string().required("Kiritish shart!"),
    telegram: Yup.string().required("Kiritish shart!"),
    instagram: Yup.string().required("Kiritish shart!"),
    facebook: Yup.string().required("Kiritish shart!"),
    twitter: Yup.string().required("Kiritish shart!"),

    fileList: Yup.array().min(1).required("Kiritish shart!"),
    logo: Yup.array().min(1).required("Kiritish shart!"),
    color: Yup.string().min(1).required("Kiritish shart!"),
  });

  const formik = useFormik({
    initialValues: {
      title: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      desc: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      client: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      full_desc: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      project_category: "",
      project_type: "",
      url: "",
      phone: "",
      date: "",
      fileList: [""],
      logo: [""],
      photo: [""],
      color: "",

      telegram: "",
      instagram: "",
      facebook: "",
      twitter: "",
    },
    validationSchema,
    onSubmit(values) {
      const formData = new FormData();
      formData.append("url", values.url);
      formData.append("title[UZL]", values.title.UZL);
      formData.append("title[RUS]", values.title.RUS);
      formData.append("title[UZK]", values.title.UZK);
      formData.append("title[ENG]", values.title.ENG);

      formData.append("desc[UZL]", values.desc.UZL);
      formData.append("desc[RUS]", values.desc.RUS);
      formData.append("desc[UZK]", values.desc.UZK);
      formData.append("desc[ENG]", values.desc.ENG);

      formData.append("client[UZL]", values.client.UZL);
      formData.append("client[RUS]", values.client.RUS);
      formData.append("client[UZK]", values.client.UZK);
      formData.append("client[ENG]", values.client.ENG);

      formData.append("full_desc[UZL]", values.full_desc.UZL);
      formData.append("full_desc[RUS]", values.full_desc.RUS);
      formData.append("full_desc[UZK]", values.full_desc.UZK);
      formData.append("full_desc[ENG]", values.full_desc.ENG);

      formData.append("project_category", values.project_category);
      formData.append("project_type", values.project_type);
      formData.append("phone", values.phone);
      formData.append("date", values.date);
      formData.append("color", values.color);

      formData.append("telegram", values.telegram);
      formData.append("instagram", values.instagram);
      formData.append("facebook", values.facebook);
      formData.append("twitter", values.twitter);

      fileList?.forEach((el) => {
        if (el.originFileObj) {
          formData.append(`files`, el.originFileObj);
        }
      });
      logo?.forEach((el) => {
        if (el.originFileObj) {
          formData.append(`file`, el.originFileObj);
        }
      });
      photo.length &&
        photo?.forEach((el) => {
          if (el.originFileObj) {
            formData.append(`image`, el.originFileObj);
          }
        });

      setLoading(true);
      if (state) {
        service
          .update(state, formData)
          .then(() => {
            navigate(-1);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        service
          .create(formData)
          .then(() => {
            navigate(-1);
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });

  useEffect(() => {
    if (state) {
      service
        .getOne(state)
        .then((resp) => {
          formik.setValues({
            title: {
              UZL: resp?.title?.UZL || "",
              UZK: resp?.title?.UZK || "",
              RUS: resp?.title?.RUS || "",
              ENG: resp?.title?.ENG || "",
            },
            desc: {
              UZL: resp?.desc?.UZL || "",
              UZK: resp?.desc?.UZK || "",
              RUS: resp?.desc?.RUS || "",
              ENG: resp?.desc?.ENG || "",
            },
            client: {
              UZL: resp?.client?.UZL || "",
              UZK: resp?.client?.UZK || "",
              RUS: resp?.client?.RUS || "",
              ENG: resp?.client?.ENG || "",
            },
            full_desc: {
              UZL: resp?.full_desc?.UZL || "",
              UZK: resp?.full_desc?.UZK || "",
              RUS: resp?.full_desc?.RUS || "",
              ENG: resp?.full_desc?.ENG || "",
            },
            project_category: resp?.category?.id || "",
            project_type: resp?.type?.id || "",
            url: resp?.url || "",
            phone: resp?.phone || "",
            date: resp?.date || "",
            color: resp?.color || "",
            telegram: resp?.telegram || "",
            instagram: resp?.instagram || "",
            facebook: resp?.facebook || "",
            twitter: resp?.twitter || "",
          });
          setFileList(() =>
            resp?.media?.map((el) => {
              return el;
            })
          );
          resp?.logo && setLogo([resp?.logo]);
          resp?.photo && setPhoto([resp?.photo]);

          setIsEdit(true);
        })
        .catch((err) => console.error(err))
        .finally(() => {});
    }
  }, []);

  const onLangChange = (key) => {
    setLanguage(key);
  };

  useEffect(() => {
    formik.setFieldValue("fileList", fileList);
    formik.setFieldValue("logo", logo);
    formik.setFieldValue("photo", photo);
  }, [fileList, logo, photo]);

  if (loading) return <Spinner />;
  return (
    <form onSubmit={formik.handleSubmit}>
      <Container>
        <Box>
          <Title>Loyiha haqida</Title>
          <LangTab defaultActiveKey="1" onChange={onLangChange} />
          <Content>
            <Select
              id="project_category"
              name="project_category"
              label="Loyiha kategoriyasi"
              allowClear
              options={categories?.map((item) => ({
                value: item?.id,
                label: item?.title,
              }))}
              onChange={(e) => formik.setFieldValue("project_category", e)}
              value={formik.values.project_category}
              status={
                formik?.errors?.project_category &&
                formik.touched.project_category
                  ? "error"
                  : ""
              }
            />
            <Select
              id="project_type"
              name="project_type"
              label="Loyiha turi (target uchun)"
              allowClear
              options={[
                { value: "1", label: "Veb-sayt" },
                { value: "2", label: "Mobil-ilova" },
                { value: "3", label: "Brending" },
                { value: "4", label: "CRM" },
                { value: "5", label: "Dashboard" },
              ]}
              onChange={(e) => formik.setFieldValue("project_type", e)}
              value={formik.values.project_type}
              status={
                formik?.errors?.project_type && formik.touched.project_type
                  ? "error"
                  : ""
              }
            />
            <Search
              label="Loyiha nomi"
              name="title"
              onChange={(e) => {
                formik.setFieldValue(`title.${language}`, e.target.value);
              }}
              value={formik?.values?.title[language]}
              status={
                formik?.errors?.title && formik.touched.title ? "error" : ""
              }
            />
            <URl
              label="URL manzil"
              value={formik?.values?.url}
              onChange={(e) => {
                const value = e.target.value;
                const sanitizedValue = value.replace(/^http:\/\//, ""); // Remove "http://"
                formik.setFieldValue("url", sanitizedValue); // Update Formik field
              }}
              name="url"
              status={formik?.errors?.url && formik.touched.url ? "error" : ""}
            />
            <TextArea
              label="Loyiha haqida qisqacha"
              name="desc"
              onChange={(e) => {
                formik.setFieldValue(`desc.${language}`, e.target.value);
              }}
              value={formik?.values?.desc[language]}
              status={
                formik?.errors?.desc && formik.touched.desc ? "error" : ""
              }
            />

            <TextArea
              label="Loyiha haqida batafsil"
              name="full_desc"
              onChange={(e) => {
                formik.setFieldValue(`full_desc.${language}`, e.target.value);
              }}
              value={formik?.values?.full_desc[language]}
              status={
                formik?.errors?.full_desc && formik.touched.full_desc
                  ? "error"
                  : ""
              }
            />
            <ImageUpload
              multiple={true}
              fileList={fileList}
              setFileList={setFileList}
              status={
                formik?.errors?.fileList && formik.touched.fileList
                  ? true
                  : false
              }
            />
          </Content>
        </Box>
        <Box>
          <Title>Boshqa ma‘lumotlar</Title>
          <Content>
            <Row>
              <DatePicker
                label="Sana"
                value={formik?.values?.date || undefined}
                onChange={(date) => formik.setFieldValue("date", date)}
                status={
                  formik?.errors?.date && formik.touched.date ? "error" : ""
                }
              />
              <Phone
                label="Telefon raqam"
                left="45px"
                value={formik.values?.phone}
                onChange={(e) =>
                  formik.setFieldValue(
                    "phone",
                    e.target.value.replace(/[^\d]+/g, "")
                  )
                }
                name="phone"
                status={
                  formik?.errors?.phone && formik?.touched?.phone ? "error" : ""
                }
              />
            </Row>
            <Search
              label="Mijoz"
              name="client"
              onChange={(e) => {
                formik.setFieldValue(`client.${language}`, e.target.value);
              }}
              value={formik?.values?.client[language]}
              status={
                formik?.errors?.client && formik.touched.client ? "error" : ""
              }
            />

            <Search
              label="Rang"
              name="color"
              onChange={(e) => {
                formik.setFieldValue(`color`, e.target.value);
              }}
              value={formik?.values?.color}
              status={
                formik?.errors?.color && formik.touched.color ? "error" : ""
              }
            />
            <ImageUpload
              label="Logotip"
              multiple={false}
              fileList={logo}
              setFileList={setLogo}
              status={
                formik?.errors?.logo && formik.touched.logo ? true : false
              }
            />
            <ImageUpload
              label="Foto"
              multiple={false}
              fileList={photo}
              setFileList={setPhoto}
              status={
                formik?.errors?.photo && formik.touched.photo ? true : false
              }
            />

            <TarmoqlarTitle>Ijtimoiy tarmoqlarimiz:</TarmoqlarTitle>

            <Search
              name="telegram"
              onChange={(e) => formik.setFieldValue("telegram", e.target.value)}
              value={formik?.values?.telegram}
              prefix={<FaTelegramPlane color="#8490A5" size={25} />}
              status={
                formik?.errors?.telegram && formik.touched.telegram
                  ? "error"
                  : ""
              }
            />
            <Search
              name="instagram"
              onChange={formik.handleChange}
              value={formik?.values?.instagram}
              prefix={<FaSquareInstagram color="#8490A5" size={25} />}
              status={
                formik?.errors?.instagram && formik.touched.instagram
                  ? "error"
                  : ""
              }
            />
            <Search
              name="facebook"
              onChange={formik.handleChange}
              prefix={<FaFacebook color="#8490A5" size={25} />}
              value={formik?.values?.facebook}
              status={
                formik?.errors?.facebook && formik.touched.facebook
                  ? "error"
                  : ""
              }
            />
            <Search
              name="twitter"
              onChange={formik.handleChange}
              prefix={<BsTwitter color="#8490A5" size={22} />}
              value={formik?.values?.twitter}
              status={
                formik?.errors?.twitter && formik.touched.twitter ? "error" : ""
              }
            />
            <ButtonContainer>
              <Button
                width="100%"
                htmlType="submit"
                text={isEdit ? "Tahrirlash" : "Saqlash"}
              />
            </ButtonContainer>
          </Content>
        </Box>
      </Container>
    </form>
  );
};

export default ProjectForm;
